import React from "react";

const HashIcon = ({ width, height, color }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.8992 12.6079L23.7638 18.3484H28.6838V23.7105H22.7268L21.3151 31H16.3194L17.731 23.7105H10.7143L9.30454 31H4.30882L5.7186 23.7105H0V18.3484H6.74802L7.89287 12.6079H2.32566V7.24997H8.92229L10.334 0H15.3278L13.9123 7.24997H20.9291L22.3389 0H27.3478L25.9286 7.24997H31V12.6121L24.8992 12.6079ZM19.9034 12.6079H12.8886L11.7532 18.3484H18.7699L19.9034 12.6079Z"
        fill="#435CFF"
      />
    </svg>
  );
};

export default HashIcon;
